import React from "react";

const TableOrder = ({tableData, deleteOrderData, detailData, currentPage}) => {
  let startNumber = 1;

  // if (currentPage !== 1) {
  //   startNumber = (currentPage - 1) * 9 + 1;
  // }

  if (currentPage !== 1) {
    startNumber = (currentPage - 1) * 15 + 1;
  }

  return (
    <table className="font-nunito-sans text-xs w-full overflow-y-auto relative">
      <thead className="sticky top-0">
        <tr className="bg-[#F9F9FC] text-black text-left">
          <th className="py-2 whitespace-nowrap">No</th>
          <th className="py-2 whitespace-nowrap">No Transaction</th>
          <th className="py-2 whitespace-nowrap">Date</th>
          <th className="py-2 whitespace-nowrap">Name Member</th>
          <th className="py-2 whitespace-nowrap">Method</th>
          <th className="py-2 whitespace-nowrap">Status</th>
          <th className="py-2 px-12 text-center whitespace-nowrap">Action</th>
        </tr>
      </thead>
      <tbody>
        {tableData.length > 0 &&
          tableData.map((row) => (
            <tr key={row.id} className="even:bg-[#F9F9FC] text-black">
              <td className="py-4 whitespace-nowrap">{startNumber++}</td>
              <td className="py-2 whitespace-nowrap">{row.code}</td>
              <td className="py-2 whitespace-nowrap">{row.datetime}</td>
              <td className="py-2 whitespace-nowrap">{row.customer_name}</td>
              <td className="py-2 whitespace-nowrap">{row.payment_method}</td>
              <td className="py-2 whitespace-nowrap">
                {row.status.toUpperCase()}
              </td>
              <td className="py-2 flex justify-center whitespace-nowrap">
                <button
                  className="ml-2 px-3 py-2 bg-red-100 hover:bg-red-400 rounded-lg mr-2"
                  onClick={() => deleteOrderData(row.id, row.code)}
                >
                  Delete
                </button>
                <button
                  className="ml-2 px-3 py-2 bg-blue-100 hover:bg-blue-400 rounded-lg mr-2"
                  onClick={() => detailData(row.id)}
                >
                  See Detail
                </button>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default TableOrder;
